export default {
    name: 'profile-thumbnail',
    data() {
        return {
            toast_config: {
                horizontalPosition: 'center',
                verticalPosition: 'top',
                mode: 'override',
                message: 'Testing'
            },
            is_favorite: false
        }
    },
    props: {
        info: {
            type: Object,
            default: () => {
                return {}
            }
        },
        layoutType: {
            validator: function (value) {
                return ['default', 'favorite', 'search'].indexOf(value) !== -1
            },
            default: 'default'
        },
        hasCloseBtn: {
            type: Boolean,
            default: false
        },
        hasNoActions: {
            type: Boolean,
            default: false
        },
    },
    methods: {
        goToPremium() {
            if (this.$store.getters['auth/profile']?.subscription_allowed) {
                this.$router.push({ name: 'user-premium' })
            }
        },
        goToProfile() {
            this.$router.push({ name: 'user-other-profile', params: { name: this.info.nick_name } })
        },
        goToChat() {
            this.$router.push({name: 'user-messages-chat', params: { name: this.info.nick_name }})
        },
        toggleFavorite() {
            if(!this.is_favorite) {
                this.$store.dispatch('profile/addFavorite', { nick_name: this.info.nick_name })
                    .then(res => {
                        this.is_favorite = true
                        this.$toast(this.$t('Favorite added successfully'), this.toast_config)
                    })
            } else {
                this.removeFavorite()
            }
        },
        removeFavorite() {
            this.$store.dispatch('profile/removeFavorite', { nick_name: this.info.nick_name })
                .then(res => {
                    this.$toast(this.$t('Favorite deleted successfully'), this.toast_config)
                    this.is_favorite = false
                    this.$emit('remove-favorite', this.info)
                })
        },
        limitText(text, length) {
            return (text.length > length) ? text.substring(0, length)+'...' : text
        }
    },
    computed: {
        showDesktop() {
            return this.$root.$children[0].width > 1199
        },
        withBlur() {
            return !Boolean(this.$store.getters['auth/profile']['remove_blur']) && Boolean(this.info.blur_thumb_picture)
        },
        locale() {
            return Vue.i18n.locale().toUpperCase()
        },
        multiBannners() {
            return [
                { img: `/images/ads/penomet/${this.locale}_ad.jpg`, link: 'https://mixi.mn/?a=155960&c=8136&p=r' },
                { img: `/images/ads/vilasil/${this.locale}_ad.jpg`, link: 'https://mixi.mn/?a=155960&c=7587&p=r' }
            ]
        },
        isPremium() {
            return this.$store.getters['auth/premium']
        },
        subscriptionAllowed() {
            return this.$store.getters['auth/subscriptionAllowed']
        }
    },
    mounted() {
        this.is_favorite = this.info.is_favorite
    }
}
